import { BEHAVIOR_TYPE, ACTION_TYPE } from '../constants'
import { makeInteger } from '../utils'

const diocesePerpetratorDiocese = 133366

const smtc = {
  behavior_hook: async function behavior_hook(object, field, action) {
    console.log('smtc.behavior_hook: ', object, field, action)

    let behaviorType = null
    if (makeInteger(field.id) === diocesePerpetratorDiocese) {
      if (action && makeInteger(action.type.id) === ACTION_TYPE.submit) {
        behaviorType = {
          id: BEHAVIOR_TYPE.required,
          name: 'Mandatory'
        }
      } else {
        behaviorType = {
          id: BEHAVIOR_TYPE.readOnly,
          name: 'Read Only'
        }
      }
    }
    console.log('smtc.behavior_hook: ', behaviorType)
    return behaviorType
  }
}

export default smtc
